var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminSearchNoResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 248,
    viewBox: "0 0 310 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.00012207,
    width: 309,
    height: 248,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.352 80.6001C261.13 80.6001 265.004 84.4863 265.004 89.2801C265.004 94.0739 261.13 97.9601 256.352 97.9601H206.912C211.69 97.9601 215.564 101.846 215.564 106.64C215.564 111.434 211.69 115.32 206.912 115.32H234.104C238.882 115.32 242.756 119.206 242.756 124C242.756 128.794 238.882 132.68 234.104 132.68H221.529C215.504 132.68 210.62 136.566 210.62 141.36C210.62 144.556 213.092 147.449 218.036 150.04C222.814 150.04 226.688 153.926 226.688 158.72C226.688 163.514 222.814 167.4 218.036 167.4H115.448C110.67 167.4 106.796 163.514 106.796 158.72C106.796 153.926 110.67 150.04 115.448 150.04H67.244C62.4657 150.04 58.592 146.154 58.592 141.36C58.592 136.566 62.4657 132.68 67.244 132.68H116.684C121.462 132.68 125.336 128.794 125.336 124C125.336 119.206 121.462 115.32 116.684 115.32H85.784C81.0057 115.32 77.132 111.434 77.132 106.64C77.132 101.846 81.0057 97.9601 85.784 97.9601H135.224C130.446 97.9601 126.572 94.0739 126.572 89.2801C126.572 84.4863 130.446 80.6001 135.224 80.6001H256.352ZM256.352 115.32C261.13 115.32 265.004 119.206 265.004 124C265.004 128.794 261.13 132.68 256.352 132.68C251.574 132.68 247.7 128.794 247.7 124C247.7 119.206 251.574 115.32 256.352 115.32Z",
    fill: "#F3F7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.438 164.92C172.306 164.92 190.844 146.322 190.844 123.38C190.844 100.438 172.306 81.8401 149.438 81.8401C126.57 81.8401 108.032 100.438 108.032 123.38C108.032 146.322 126.57 164.92 149.438 164.92Z",
    fill: "#F3F7FF",
    stroke: "#1F64E7",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.803 155.613C144.977 156.015 147.189 156.224 149.438 156.24C167.528 156.24 182.192 141.528 182.192 123.38C182.192 105.232 167.528 90.5201 149.438 90.5201C144.791 90.5201 140.37 91.491 136.366 93.2415C129.407 96.2835 123.707 101.68 120.264 108.428C117.975 112.913 116.684 117.995 116.684 123.38C116.684 128.266 117.747 132.902 119.653 137.07C121.014 140.045 122.805 142.782 124.946 145.199",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.803 155.613C144.977 156.015 147.189 156.224 149.438 156.24C167.528 156.24 182.192 141.528 182.192 123.38C182.192 105.232 167.528 90.5201 149.438 90.5201C144.791 90.5201 140.37 91.491 136.366 93.2415C129.407 96.2835 123.707 101.68 120.264 108.428C117.975 112.913 116.684 117.995 116.684 123.38C116.684 128.266 117.747 132.902 119.653 137.07C121.014 140.045 122.805 142.782 124.946 145.199",
    stroke: "#1F64E7",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.794 148.893C131.449 151.058 134.448 152.814 137.697 154.066",
    stroke: "#1F64E7",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M183.428 156.24L190.844 163.68",
    stroke: "#1F64E7",
    strokeWidth: 2.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.645 162.478C187.306 164.825 187.306 168.63 189.645 170.977L203.347 184.723C205.686 187.069 209.479 187.069 211.819 184.723C214.158 182.376 214.158 178.57 211.819 176.223L198.117 162.478C195.778 160.131 191.985 160.131 189.645 162.478Z",
    fill: "#E8F0FE",
    stroke: "#1F64E7",
    strokeWidth: 2.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M195.788 164.92L209.384 178.56",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.404 109.12C141.404 123.502 153.025 135.16 167.36 135.16C170.176 135.16 172.887 134.71 175.426 133.878C171.282 144.196 161.208 151.479 149.438 151.479C133.969 151.479 121.429 138.899 121.429 123.38C121.429 109.318 131.726 97.6685 145.168 95.6055C142.78 99.5465 141.404 104.172 141.404 109.12Z",
    fill: "#E8F0FE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M150.056 100.44C148.482 100.44 146.944 100.595 145.457 100.892M140.965 102.27C132.51 105.835 126.572 114.222 126.572 124",
    stroke: "#75A4FE",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M215.781 123.724H205.676M223.598 114.08H202.369H223.598ZM232.25 114.08H229.505H232.25Z",
    stroke: "#75A4FE",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M104.541 151.004H94.4361M98.7621 140.12H77.5328H98.7621ZM70.3341 140.12H65.1167H70.3341Z",
    stroke: "#75A4FE",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminSearchNoResults);
export default __webpack_public_path__ + "static/media/admin-search-no-results.a0471e241d9715e1e55f7156a276c2b3.svg";
export { ForwardRef as ReactComponent };